import { IWithSummaryModel } from "src/app/modules/common/permission/api/entity/iWithSummary.model";
import { ProviderServiceOptionSummaryModel } from "./providerServiceOptionSummary.model";
import {ProductSummaryModel} from "../../../../../product/api/entity/productSummary.model";
import {ProviderServiceSummaryModel} from "../../../api/entity/providerServiceSummary.model";

export class ProviderServiceOptionModel implements IWithSummaryModel<ProviderServiceOptionSummaryModel> {
    summary: ProviderServiceOptionSummaryModel;
    product: ProductSummaryModel;
    providerService: ProviderServiceSummaryModel;
}

